export default __webpack_public_path__ + "static/pattern-3df3b13f2c9d1c7eb07be80d51b3fe6a.png";